import { gql } from '@apollo/client';

export const ALL_ORDERS_QUERY = gql`
  query AllOrdersQuery {
    allOrders {
      id
      paymentIntentId
      paymentMethod {
        brand
        last4
        id
      }
      invoiceId
      amount
      audienceName
      audienceFilters
      audienceSnapshot {
        filters
        plainText
        capturedAt
      }
      recordsIncluded
      createdDate
      orderType
      seedFileId
      seedFileName
      packageName
      packageId
      packageVariables
      user {
        id
        email
        paymentType
      }
    }
  }
`;

/**
 * Every activation, across every user — the admin view of what data went to
 * which destination (ATAD-132). Guarded server-side by `anyAdminProtected`,
 * so admins and finance-admins both see it.
 *
 * `audienceName` / `destinationPartnerName` are denormalized onto the
 * activation and are all that survives when an audience has been deleted or
 * when the row predates the destination-ref fix, so both are selected as
 * fallbacks for their populated counterparts.
 *
 * Deliberately selects no s3Config / sftpConfig: those subdocuments hold
 * plaintext credentials and nothing in this table renders them.
 */
export const ALL_ACTIVATIONS_QUERY = gql`
  query AllActivationsQuery {
    allActivations {
      id
      createdAt
      startedAt
      finishedAt
      audienceName
      recordsIncluded
      processingStatus
      destinationPartnerName
      deliveredBucket
      deliveredKey
      deliveredAt
      user {
        id
        email
        companyName
      }
      audience {
        id
        name
        recordsIncluded
        recordsAvailable
        filters
      }
      destinationPartner {
        id
        name
        slug
        displayName
        filenameSuffix
      }
    }
  }
`;
